import {
  getEffectiveTrackMatchStatusId,
  isTrackMatchStatusProcessing,
} from '@/constants/trackMatchStatus';

/** Whether persisted or in-memory live track row data is track match status Processing (id 7). */
export function isLiveTrackMatchDataProcessing(
  matchData: Record<string, unknown> | undefined
): boolean {
  return isTrackMatchStatusProcessing(getEffectiveTrackMatchStatusId(matchData));
}

/** True when any live track with pending UI actions is in Processing (save must not run). */
export function pendingSaveBlockedByProcessingLiveTrack(
  liveTrackIdsWithPendingActions: Iterable<string | number>,
  isLiveTrackProcessing: (liveTrackId: string | number) => boolean
): boolean {
  for (const liveTrackId of liveTrackIdsWithPendingActions) {
    if (isLiveTrackProcessing(liveTrackId)) {
      return true;
    }
  }
  return false;
}
